import React from 'react';

import { Box, Flex } from '@chakra-ui/react';
import { ChangeTimelineRealignModal } from 'components/RabbitOKRSidePanel/Components/ChangeTimelineRealignModal';
import { SECONDARY_PANEL_TYPES } from 'components/RabbitOKRSidePanel/krDrawerSecondaryPanelSlice';
import { TimelineSelect } from 'components/TimelineSelect/TimelineSelect';
import { useSelector } from 'react-redux';
import { kRDrawerSecondaryPanelSelector } from 'selectors/krSecondaryPanel';

import { AgGridSearch } from 'uiToolkitV1/AgGridWrapperV2';
import { AgGridExpandCollapseButton } from 'uiToolkitV1/AgGridWrapperV2/components/ExpandCollapseButton/AgGridExpandCollapseButton';

import { useChangeTimelineRealignModalLogic } from './useChangeTimelineRealignModalLogic';

export const RealignHeader = ({ gridRef, localSelectedTimePeriod, setLocalSelectedTimePeriod }) => {
  const { type, details } = useSelector(kRDrawerSecondaryPanelSelector);

  const {
    isChangeTimelineModalOpen,
    handleCloseModal,
    handleNotRealignChildrenOKRs,
    handleRealignChildrenOKRs,
    onSelectedTimeBoundPeriodChange,
  } = useChangeTimelineRealignModalLogic({ details });

  const isChildrenRealignPanel = type === SECONDARY_PANEL_TYPES.REALIGN_CHILDREN;

  const hasUserAlreadyChoseChildrenRealignStrategy =
    type === SECONDARY_PANEL_TYPES.REALIGN_OKR_WITHOUT_CHILDREN_REALIGN_CONFIRMATION_MODAL;

  const isDeletionChildrenRealignPanel = type === SECONDARY_PANEL_TYPES.REALIGN_CHILDREN_AND_DELETE;

  const showChangeTimelineRealignConfirmationModal =
    !isChildrenRealignPanel && !hasUserAlreadyChoseChildrenRealignStrategy && !isDeletionChildrenRealignPanel;

  const handleTimePeriodSelection = (selectedTimePeriod) => {
    if (showChangeTimelineRealignConfirmationModal) {
      onSelectedTimeBoundPeriodChange(selectedTimePeriod);
      return;
    }

    setLocalSelectedTimePeriod(selectedTimePeriod);
  };

  return (
    <Flex alignItems="center" justifyContent="space-between" px={2} py={3}>
      <Box flex={1}>
        <AgGridSearch placeholder="Search across title, owner, progress etc." gridRef={gridRef} />
      </Box>

      <Flex justifyContent="flex-end">
        <AgGridExpandCollapseButton gridRef={gridRef} defaultExpandAll />
        <Box minW={'80px'}>
          <TimelineSelect selectedTimeline={localSelectedTimePeriod} onSelect={handleTimePeriodSelection} />
        </Box>
        <ChangeTimelineRealignModal
          okrType={details?.okrType}
          isOpen={isChangeTimelineModalOpen}
          onClose={handleCloseModal}
          handleRealignChildrenOKRs={handleRealignChildrenOKRs}
          handleNotRealignChildrenOKRs={handleNotRealignChildrenOKRs}
        />
      </Flex>
    </Flex>
  );
};
